import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { LightMode, DarkMode } from "@mui/icons-material";
import { useTheme } from "../editor/ThemeContextEditor";

const ThemeToggleEditor = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <Tooltip
      title={`Cambiar a modo ${isDarkMode ? "claro" : "oscuro"}`}
      placement="right"
      arrow
    >
      <IconButton onClick={toggleTheme}>
        {isDarkMode ? <LightMode /> : <DarkMode />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggleEditor;
